import React from 'react'
import './streampacks.css'
import IMG1 from '../../assets/sp1.png'
import IMG2 from '../../assets/sp2.png'
import IMG3 from '../../assets/sp3.png'
import IMG4 from '../../assets/sp4.png'
import IMG5 from '../../assets/sp5.png'
import IMG6 from '../../assets/sp6.png'
import { useNavigate } from 'react-router-dom'
// import Store from '../../Store'


const data = [
  {
    id: 1,
    image: IMG1,
    title: 'This is a streampacks item title',
    github: 'https://github.com',
    demo: 'https://dribbble.com'
  },
  {
    id: 2,
    image: IMG2,
    title: 'This is a streampacks item title',
    github: 'https://github.com',
    demo: 'https://dribbble.com'
  },
  {
    id: 3,
    image: IMG3,
    title: 'This is a streampacks item title',
    github: 'https://github.com',
    demo: 'https://dribbble.com'
  },
  {
    id: 4,
    image: IMG4,
    title: 'This is a streampacks item title',
    github: 'https://github.com',
    demo: 'https://dribbble.com'
  },
  {
    id: 5,
    image: IMG5,
    title: 'This is a streampacks item title',
    github: 'https://github.com',
    demo: 'https://dribbble.com'
  },
  {
    id: 6,
    image: IMG6,
    title: 'This is a streampacks item title',
    github: 'https://github.com',
    demo: 'https://dribbble.com'
  },
]


const Streampacks = () => {

  const navigate = useNavigate();
  
  const view = () => {
    navigate('/Store')
  };
  const buy = () => {
    navigate('/Store')
  };

  return (
    <section className='streampack_section'>
      <h2>Streampacks</h2>
      
      <div className="container streampacks_container">
        {
          data.map(({id, image, title, github, demo}) => {
            return(
              <article key={id} className="streampacks_item">
          <div className="streampacks_item-image">
            <img src={image} alt={title} />
          </div>
          <h3>{title}</h3>
          <div className='streampacks_item-cta'>
          <button onClick={() => view()} className='btn'>View</button>
          <button onClick={() => buy()} className='btn btn-primary'>Buy</button>

{/*           <a onClick={() => view()} className='btn' target='_blank'>View</a>
          <a onClick={() => buy()} className='btn btn-primary' target='_blank'>Buy</a> */}
          </div>
        </article>
            )
          })
        }
      </div>
     <div className='view-more'>
     <button className='btn btn-primary'>view more</button>
     </div>
    </section>

  )
}

export default Streampacks
